import {Component} from "@angular/core";

import {AppController} from "../AppController";

@Component({
  selector: "app-review-page",
  templateUrl: "./ReviewPage.html",
})
export class ReviewPage {

  public constructor(private readonly _appController: AppController) {}

  public get appController() {
    return this._appController;
  }

  public get organization() {
    return this.appController.organization;
  }

  public toLanguageName(languageCode: string) {
    const language = this.appController.availableLanguages.find(language => language.code === languageCode);
    return (language ? language.name : languageCode);
  }

  public toCountryName(countryCode: string) {
    const country = this.appController.availableCountries.find(country => country.code === countryCode);
    return (country ? country.name : countryCode);
  }

  public print() {
    const printData = document.getElementById("printableSection").innerHTML;
    const popupWin = window.open("", "_blank", "width=800,height=800");
    popupWin.document.open();
    popupWin.document.write(`
      <!doctype html>
      <html>
      <body style="font-family: sans-serif; font-size: 10pt; line-height: 130%">
        <img src="assets/sprplus_logo.gif">
        ${printData}
      </body>
      </html>
    `);
    popupWin.onload = () => {popupWin.print(); popupWin.close()};
    popupWin.document.close();
  }

}
